import { Flex, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import useBreakpoint from 'hooks/useBreakpoint';
import { loadStories } from 'modules/stories/storiesSlice';
import { isCorporateThemeSelector } from 'modules/app/appSlice';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import Carousel from 'components/Carousel/Carousel';
import Loader from 'components/Loader/Loader';
import { mq } from 'styles/breakpoints';

import BoxContent from '../BoxContent/BoxContent';
import BoxHeader from '../BoxHeader/BoxHeader';
import BoxMain from '../BoxMain/BoxMain';
import Video from './Video';

const CarouselWrapper = styled.div`
  width: 100%;

  .slick-dots {
    justify-content: center;

    > div {
      display: none;
    }
  }

  ${mq.lg} {
    .slick-dots {
      justify-content: space-between;

      > div {
        display: flex;
      }
    }
  }
`;

const CarouselItem = styled(Flex)`
  width: 100%;
  position: relative;
  margin-top: 25px;
  justify-content: center;
`;

interface Props {
  small?: boolean;
  boxWidth?: BoxWidth;
  animate?: boolean;
  includeBottomMargin?: boolean;
}
const Slideshow: FC<Props> = ({ small, boxWidth = 'md', animate, includeBottomMargin }) => {
  const { loading, items } = useSelector((state: RootState) => state.stories);
  const isCorporateTheme = useSelector(isCorporateThemeSelector);
  const { isTablet } = useBreakpoint();
  const { colors } = useTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadStories());
  }, []);

  return (
    <BoxContent boxWidth={boxWidth} includeRightMargin animate={animate} mb={includeBottomMargin ? '30px !important' : ''}>
      <BoxMain pb={isTablet ? '50px' : undefined}>
        {loading ? (
          <Flex w="100%" justifyContent="center">
            <Loader small />
          </Flex>
        ) : (
          <Flex pb={small ? '20px' : '0px'}>
            <CarouselWrapper className="carousel-wrapper">
              <Carousel color={isCorporateTheme ? colors.primary[500] : colors.secondary[800]}>
                {items.map(({ title, videoUrl }) => (
                  <Flex direction="column" key={title}>
                    <BoxHeader title={title} />
                    <CarouselItem>
                      <Video url={videoUrl} title={title} small={small} />
                    </CarouselItem>
                  </Flex>
                ))}
              </Carousel>
            </CarouselWrapper>
          </Flex>
        )}
      </BoxMain>
    </BoxContent>
  );
};

export default Slideshow;
